import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

export default function ArticleStandfirst() {
  const { article } = useRouteResponse("articlePage");
  if (!article?.standfirst) return null;

  return (
    <div className="py-4">
      <div className="mx-auto w-12 border-t-2 border-solid border-divider-brand" />
      <p className="py-5 text-center text-header-2 font-medium text-primary">
        {article.standfirst}
      </p>
      <div className="mx-auto w-12 border-t-2 border-solid border-divider-brand" />
    </div>
  );
}
